var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundedRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8916 18.1368C25.09 12.6765 23.2565 5.6578 17.797 2.45894C12.3376 -0.73983 5.32007 1.09382 2.12168 6.55418C-1.07668 12.0145 0.756794 19.0332 6.21629 22.2321C11.6756 25.4308 18.6932 23.5972 21.8916 18.1368ZM16.0404 5.45418C19.8492 7.6788 21.1271 12.577 18.897 16.3798C16.6728 20.1891 11.7752 21.4673 7.97291 19.2368C4.16413 17.0122 2.88617 12.114 5.11627 8.31125C7.34053 4.50193 12.2381 3.22367 16.0404 5.45418Z",
    stroke: "#FF543F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedRed);
export default __webpack_public_path__ + "static/media/roundedRed.6677d1c05bee25c5e811d6e6d1fcba8b.svg";
export { ForwardRef as ReactComponent };